<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-l">
		<wa-button [routerLink]="['/frameworks/jquery-ui']" appearance="plain" variant="neutral">&larr; Back to jQuery UI</wa-button>
		<div class="wa-cluster" style="align-items:center;justify-content:space-between;">
			<h1 waHeading="xl" waText>JQUIDroppable</h1>
			<a href="javascript:void(0)" onclick="document.getElementById('examples-section')?.scrollIntoView({behavior:'smooth'})" style="color:var(--wa-color-brand-normal);cursor:pointer;font-size:var(--wa-font-size-s);white-space:nowrap;">Examples ↓</a>
		</div>
		<p waBody="m" waColorText="quiet" waText>Define drop targets for draggable elements. Supports accept filtering, tolerance modes, and visual feedback.</p>
		<wa-details appearance="outlined" summary="Import, Interfaces & Constructors">
			<div class="wa-stack wa-gap-m">
				<div waCaption="s" waFontWeight="semibold" waText>IMPORT</div>
				<markdown [data]="mdContent_201" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				<div waCaption="s" waFontWeight="semibold" waText>IMPLEMENTS</div>
				<div class="wa-cluster wa-gap-xs">
					<wa-tag pill variant="neutral">IJQUIDroppable</wa-tag>
				</div>
				<div waCaption="s" waFontWeight="semibold" waText>CONSTRUCTORS</div>
				<markdown [data]="mdContent_202" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				<p waBody="s" waColorText="quiet" waText>Creates a droppable target</p>
			</div>
		</wa-details>
		<wa-details open summary="Properties (2)">
			<table style="border-collapse:collapse;width:100%;">
				<thead>
					<tr style="border-bottom:2px solid var(--wa-color-neutral-200);">
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Property</th>
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Type</th>
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Default</th>
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Description</th>
					</tr>
				</thead>
				<tbody>
					<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
						<td style="color:var(--wa-color-brand-normal);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);">accept</td>
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">String</td>
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">*</td>
						<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">Selector to filter which draggables are accepted</td>
					</tr>
					<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
						<td style="color:var(--wa-color-brand-normal);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);">tolerance</td>
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">String</td>
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">intersect</td>
						<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">Tolerance mode: fit, intersect, pointer, touch</td>
					</tr>
				</tbody>
			</table>
		</wa-details>
		<wa-details open summary="Methods (1)">
			<table style="border-collapse:collapse;width:100%;">
				<thead>
					<tr style="border-bottom:2px solid var(--wa-color-neutral-200);">
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Signature</th>
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Description</th>
					</tr>
				</thead>
				<tbody>
					<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);">getOptions()</td>
						<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">Returns the droppable options</td>
					</tr>
				</tbody>
			</table>
		</wa-details>
		<div class="wa-stack wa-gap-m" id="examples-section">
			<h2 waHeading="l" waText>Examples</h2>
			<div class="wa-stack wa-gap-xs">
				<h4 waHeading="s" waText>Droppable Target</h4>
				<p waBody="s" waColorText="quiet" waText>Create a drop target.</p>
				<markdown [data]="mdContent_203" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
			</div>
		</div>
	</div>
</div>